import { useParams, useNavigate } from 'react-router-dom';
import { appStyles, logoImage } from './app.style'
import { useState } from 'react';
import { Paciente } from './loginApp.types';
import { regexOnlyNumbersUpTo8, validateEmail } from '../helpers/validations.helper';
import toast from 'react-hot-toast';
import { api } from '../data/api';
import { ButtonInApp } from './ButtonInApp.component';
import { ContainerApp, ContentApp, FooterApp, HeaderApp, LabelApp } from './Layout.app';
import { AppTermsAndConditions } from '../legals/TermsAndConditions.component';
import { Role } from '../data/types/medico.types';
import { useAuth } from '../auth/AuthContext';

export const RegisterApp = () => {
	const { dni } = useParams<{ dni: string }>();
	const { login } = useAuth();
  
	const navigate = useNavigate();
	const [formData, setFormData] = useState<Partial<Paciente & {passconf: string}>>({
		dni: '',
		nombre: '',
		apellido: '',
		email: '',
		password: '',
		passconf: ''
	})

	const [errors, setErrors] = useState<Record<string, string>>({});
	const [aceptadoTerminos, setAceptadoTerminos] = useState(false);
	const [showTerminos, setShowTerminos] = useState(false);

	const handleInputChange = (field: string, value: string) => {
		setFormData({...formData, [field]: value});
		
		// Limpiar errores al escribir
		if (errors[field]) {
			setErrors({...errors, [field]: ''});
		}
	}

	const validateField = (field: string, value: string) => {
		let customMessage = '';
		
		switch (field) {
			case 'nombre':
				if (!value || value.length < 2) customMessage = 'El nombre debe tener al menos 2 caracteres';
				break;
			case 'apellido':
				if (!value || value.length < 2) customMessage = 'El apellido debe tener al menos 2 caracteres';
				break;
			case 'email':
				if (!value || !validateEmail(value)) customMessage = 'Ingrese un email válido';
				break;
			case 'password':
				if (!value || value.length < 4 || !value.match(regexOnlyNumbersUpTo8) ) customMessage = 'El pin debe tener 4 dígitos numéricos';
				break;
			case 'passconf':
				if (!value || value.length < 4 || !value.match(regexOnlyNumbersUpTo8) ) customMessage = 'El pin debe tener 4 dígitos numéricos';
				else if (value !== formData.password) customMessage = 'Los pins deben coincidir';
				break;
		}
		console.log("### CUSTOM MESSAGE ", customMessage);
		setErrors({...errors, [field]: customMessage});
		// input.setCustomValidity(customMessage);
	}

	const handleInputBlur = (field: string, value: string) => {
		validateField(field, value)
	}

	const validateAllFields = () => {
		Object.keys(formData).forEach(field => {
			validateField(field, formData[field as keyof typeof formData] as string)
		})
		return Object.keys(errors).length === 0 || Object.values(errors).every(error => error === '');
	}

	const handleSubmit = async (e?: React.FormEvent) => {
		e?.preventDefault();

		if (!validateAllFields()) return;

		if (!aceptadoTerminos) {
			toast.error('Debes aceptar los Términos y Condiciones');
			return;
		}

		// if (!validateForm()) return;
		try {
			const {data: loginResponse} = await api.post('/api/authp/register', {...formData, dni});


			await login( loginResponse.token, `${loginResponse.nombre} ${loginResponse.apellido}`, Role.PACIENTE);

			navigate('/app/wizard?actionType=first')
		} catch (err) {
			console.error("### error", err);
			toast.error('Error guardando');
		}
	}

	return (
		<ContainerApp>
			<HeaderApp title={'Registrate!'} />
				<ContentApp>
					{!showTerminos ? (
						<form onSubmit={handleSubmit} style={appStyles.formWrap}>
							<LabelApp label="Número de DNI" />
							<input 
								type="text" 
								placeholder="DNI" 
								value={dni}
								style={appStyles.input} 
								disabled
							/>
							{errors.dni && <p style={appStyles.error}>{errors.dni}</p>}
							<LabelApp label="Nombre" />
							<input 
								type="text" 
								name="nombre"
								placeholder="Nombre" 
								style={appStyles.input} 
								value={formData.nombre}
								onChange={(e) => handleInputChange('nombre', e.target.value)}
								onBlur={(e) => handleInputBlur('nombre', e.target.value)}
								required
							/>
							{errors.nombre && <p style={appStyles.error}>{errors.nombre}</p>}
							<LabelApp label="Apellido" />
							<input 
								type="text" 
								name="apellido"
								placeholder="Apellido" 
								style={appStyles.input}
								value={formData.apellido}
								onChange={(e) => handleInputChange('apellido', e.target.value)}
								onBlur={(e) => handleInputBlur('apellido', e.target.value)}
								required
							/>
							{errors.apellido && <p style={appStyles.error}>{errors.apellido}</p>}
							<LabelApp label="Email" />
							<input 
								type="email" 
								name="email"
								placeholder="Email" 
								style={appStyles.input}
								value={formData.email}
								onChange={(e) => handleInputChange('email', e.target.value)}
								onBlur={(e) => handleInputBlur('email', e.target.value)}
								required
							/>
							{errors.email && <p style={appStyles.error}>{errors.email}</p>}
							<LabelApp label="Pin de 4 dígitos" />
							<input
								type="password"
								name="password"
								placeholder="PIN"
								style={appStyles.input}
								maxLength={4}
								minLength={4}
								value={formData.password}
								onChange={(e) => handleInputChange('password', e.target.value)}
								onBlur={(e) => handleInputBlur('password', e.target.value)}
								required
							/>
							{errors.password && <p style={appStyles.error}>{errors.password}</p>}
							<LabelApp label="Repita el Pin" />
							<input
								type="password"
								name="passconf"
								placeholder="Repetir el Pin"
								style={appStyles.input}
								maxLength={4}
								minLength={4}
								value={formData.passconf}
								onChange={(e) => handleInputChange('passconf', e.target.value)}
								onBlur={(e) => handleInputBlur('passconf', e.target.value)}
								required
							/>
							{errors.passconf && <p style={appStyles.error}>{errors.passconf}</p>}
							<div style={{
								display: 'flex',
								alignItems: 'center',
								marginBottom: '1rem',
								fontSize: '0.9rem',
								color: '#2d3748'
							}}>
								<input
									type="checkbox"
									id="aceptoTerminos"
									checked={aceptadoTerminos}
									onChange={(e) => setAceptadoTerminos(e.target.checked)}
									style={{
										marginRight: '0.5rem',
										width: '18px',
										height: '18px',
										cursor: 'pointer'
									}}
									required
								/>
								<label htmlFor="aceptoTerminos" style={{ cursor: 'pointer', userSelect: 'none' }}>
									Acepto los{' '}
									<span
										onClick={(e) => {
											e.preventDefault();
											setShowTerminos(true);
										}}
										style={{
											color: '#5E7390',
											textDecoration: 'underline',
											cursor: 'pointer',
											fontWeight: '500'
										}}
									>
										Términos y Condiciones
									</span>
								</label>
							</div>
						</form>
					) : (
						<AppTermsAndConditions />
					)}
				</ContentApp>
				<FooterApp>
					{(!showTerminos) && <ButtonInApp 
						label="Enviar"
						type="submit"
						disabled={!aceptadoTerminos || (Object.keys(errors).length > 0 && Object.values(errors).some(error => error !== ''))}
						onClick={() => handleSubmit()}
					/>}
					{(showTerminos) && <ButtonInApp 
						label="Atrás"
						type="button"
						onClick={() => setShowTerminos(false)}
					/>}
				</FooterApp>
		</ContainerApp>
	)
}